import type { RouteRecordRaw } from 'vue-router'

import bouyguesInStoreRoutes from './flows/bouygues-in-store/routes'
import eCommerceRoutes from './flows/e-commerce/routes'
import giftCardRoutes from './flows/gift-card/routes'
import partnersRoutes from './flows/partners/routes'

export default (): RouteRecordRaw[] => {
  return [
    // Standard e-commerce checkout (/f2).
    ...eCommerceRoutes,

    // BM-as-a-Service partner entry points (/partners/:partnerName/checkout).
    // The middleware clears the cart + adds a listing, then redirects into the standard /f2 flow.
    ...partnersRoutes,

    // Bouygues in-store magic-link flow: a sales agent generates a link for
    // the customer to complete purchase on their own device.
    ...bouyguesInStoreRoutes,

    // Standalone gift card checkout, separate from the main cart flow.
    ...giftCardRoutes(),
  ]
}
